export const ErrorMapperEmailConst = {
    81004: /* translationId */ 'ERRORS.81004',
    83303: /* translationId */ 'TR_API-ERROR_83303_TR',
    83604: /* translationId */ 'ERRORS.83604'
};
